import { render } from "./EmailInterface.vue?vue&type=template&id=64292ef4&scoped=true"
import script from "./EmailInterface.vue?vue&type=script&lang=ts"
export * from "./EmailInterface.vue?vue&type=script&lang=ts"

import "./EmailInterface.vue?vue&type=style&index=0&id=64292ef4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-64292ef4"

export default script